import { Injectable, numberAttribute } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of, Subject } from 'rxjs';

import { environment } from 'src/environments/environment';
import { METRICS_ENDPOINT } from './maintenance-mode.service';

type TODO = unknown;

@Injectable()
export class MaintenanceModeHttpService {
  constructor(public http: HttpClient) {}

  get(endpoint: string = METRICS_ENDPOINT): Observable<TODO> {
    const url = `${environment.metricsApiUrl}/${endpoint}`;
    return this.http.get<TODO>(url);
  }
}
